<template>
  <static-fullscreen-card :loaded="loaded">
    <template v-slot:title v-if="loaded"> ({{ data.id }}) {{ data.name }} [{{ statusCurrent.text }}] </template>
    <template v-slot:actions v-if="loaded">
      <a-btn-add v-if="getAccess('object.create')" @click="tryRedirect()" :disabled="loading" icon="fas fa-people-arrows" title="" />
      <v-btn-toggle
        v-if="getAccess('object.showPlanning') || getAccess('object.showStatistic')"
        v-model="objectTypeView"
        mandatory
        borderless
        dense
        class="v-btn"
        @change="changeTab(objectTypeView, 'type')"
      >
        <v-btn value="tabObjectView-main" color="#d0bf9c" class="ml-0">
          <span class="hidden-lg-and-down">Общий</span>
          <v-icon :right="$vuetify.breakpoint.lgAndUp"> fas fa-wrench </v-icon>
        </v-btn>
        <v-btn value="tabObjectView-stat" class="ml-1" color="#d0bf9c">
          <span class="hidden-lg-and-down">Планирование</span>
          <v-icon :right="$vuetify.breakpoint.lgAndUp"> fas fa-chart-bar </v-icon>
        </v-btn>
      </v-btn-toggle>
      <v-btn v-if="editObject" class="ml-1" color="blue" title="Импорт из сметы" @click="onSelectEstimate">
        <v-icon> mdi-home-import-outline </v-icon>
      </v-btn>

      <a-btn-status v-if="statusObject" :items="statusItems" @click="clickStatus($event)" :disabled="loading" />
      <a-btn-edit v-if="showObject && $root.profile.role > 20" :title="editObject ? 'Редактирование' : 'Просмотр'" @click="showEditDialog = true" />
      <a-btn-edit v-if="$root.profile.role == 10001" @click="oldDoc = !oldDoc" :title="'docs'" />
    </template>
    <div v-if="loaded">
      <portal to="v-goup" v-if="idShow">
        <v-btn class="mr-3" fab small @click="$emit('close', data)">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </portal>
      <portal to="v-main">
        <s-selectList ref="selectList" mode="async" />
        <edit-dialog v-model="showEditDialog" :id="id" :api="url" v-if="showObject" />
        <StateSaleDialog v-model="showStateSaleDialog" :id="id" :object="JSON.parse(JSON.stringify(data))" />
        <s-quick-addDocument v-if="showAddDocDialog" v-model="showAddDocDialog" :id="id" :api="url" :modelDoc="addDocModel" />
      </portal>
      <v-tabs-items v-model="objectTypeView" class="transparent" touchless>
        <v-tab-item :id="`tabObjectView-main`">
          <v-row v-if="!loading">
            <v-col cols="12" sm="6">
              <material-card color="secondary">
                <template v-slot:heading>
                  <v-tabs v-model="tab_photo" background-color="transparent" slider-color="white">
                    <v-tab class="mr-3">
                      {{ "Фото объекта" }}
                    </v-tab>
                    <v-tab class="mr-3">
                      {{ "Дизайн-проект" }}
                    </v-tab>
                  </v-tabs>
                </template>
                <v-tabs-items v-model="tab_photo" class="transparent" style="min-height: 200px" touchless>
                  <v-tab-item>
                    <a-view-images :value="data.photos" :style="{ height: blockHeight + 'px' }" />
                  </v-tab-item>
                  <v-tab-item>
                    <a-view-images :value="data.photos_design" :style="{ height: blockHeight + 'px' }" />
                  </v-tab-item>
                </v-tabs-items>
              </material-card>
            </v-col>
            <v-col cols="12" sm="6">
              <material-card color="secondary">
                <template v-slot:heading1>
                  <div class="px-3 py-1">основная информация</div>
                </template>
                <template v-slot:heading>
                  <v-tabs v-model="tab_info" background-color="transparent" slider-color="white" center-active show-arrows>
                    <v-tab v-if="tab.show" class="mr-3" v-for="tab in infoTabs" :key="`tab-${tab.name}`">
                      {{ tab.title }}
                    </v-tab>
                  </v-tabs>
                </template>
                <v-tabs-items v-model="tab_info" class="transparent" style="min-height: 200px" touchless>
                  <v-tab-item v-if="tab.show" v-for="tab in infoTabs" :key="`tab-${tab.name}`">
                    <v-card-text v-if="tab.name == 'auto-task'" style="height: 300px; overflow: auto" class="pa-0">
                      <v-simple-table dense class="block_master_stat">
                        <thead>
                          <tr>
                            <td class="text-center font-weight-bold px-0 mx-1" :style="`height: 22px; `">Задача</td>
                          </tr>
                        </thead>
                        <tbody v-if="loaded">
                          <tr v-for="(row, i) in data.tasks" :key="i">
                            <td class="text-left px-0 pl-2" :style="`height: 38px; `">
                              <component :is="'a-view-string'" :model="{ name: 'cc', type: 'number' }" :value="row['name']" />
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-card-text>

                    <a-form-view
                      v-if="tab.name == 'info'"
                      :value="data"
                      :model="modelRight"
                      :config="{ dense: true, hideNull: true }"
                      style="min-height: 330px"
                      class="block_master"
                    />
                    <a-form-view
                      v-if="tab.name == 'finance'"
                      :value="data"
                      :model="[
                        { name: 'investment_status', value: investmentText, title: 'Объем финансирования', type: 'string', showNull: true },
                        $root.profile.role < 20 ? {} : { name: 'finance_status', value: balanceText, title: 'Финансовый статус', type: 'string', showNull: true },
                      ]"
                      :config="{ dense: true, hideNull: true }"
                      style="min-height: 330px"
                      class="block_master"
                    />
                    <TabGoodsSummary v-if="tab.name == 'goods'" :id="data.id" />
                  </v-tab-item>
                </v-tabs-items>
              </material-card>
            </v-col>
            <v-col cols="12" v-if="showObject && !loading">
              <material-card color="third">
                <template v-slot:heading>
                  <div>
                    <v-tabs dense v-model="tab" background-color="transparent" slider-color="white" show-arrows center-active @change="changeTab(tab)">
                      <v-tab v-for="(tab, i) in tabs" :key="i" v-if="showTab(tab)" :href="`#tab-${tab.name}`" class="mr-3">
                        {{ tab.title }}
                        <v-icon v-if="tab.icon && showObject" @click.native.prevent.stop="clickTabIcon(tab)">{{ tab.icon }}</v-icon>
                      </v-tab>
                    </v-tabs>
                  </div>
                </template>
                <v-tabs-items v-if="loaded" v-model="tab" class="transparent" style="min-height: 200px" touchless>
                  <v-tab-item v-for="(tab, i) in tabs" :key="i" v-if="showTab(tab)" :id="`tab-${tab.name}`" :data-name="`${tab.name} section`">
                    <TabWorks v-if="tab.name == 'works'" :data="data" :id="id" />
                    <TabGoods v-if="tab.name == 'goods'" :data="data" :id="id" />
                    <TabContract v-if="tab.name == 'contract'" :data="data" :id="id" :filter="{ object_id: id }" />
                    <TabReports v-if="tab.name == 'reports'" :data="data" :id="id" />
                    <TabFurnitureReports v-if="tab.name == 'furniture'" :data="data" :id="id" />
                    <TabDocs
                      v-if="'doc,doc_adv,doc_law,doc_furniture'.split(',').includes(tab.name)"
                      :data="data"
                      :model="model.find((el) => el.name == tab.name)"
                      :category="showDocs(tab.name)"
                      @addDocs="addNewDocs(tab.name)"
                    />
                    <TabBalance v-if="tab.name == 'balance'" :data="{ data, id }" />
                  </v-tab-item>
                </v-tabs-items>
              </material-card>
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item :id="`tabObjectView-stat`">
          <ViewPlanning v-if="true" :idShow="id" />
        </v-tab-item>
      </v-tabs-items>
      <div v-if="loading" class="loading-block">
        <div class="loader"></div>
      </div>
      <s-edit-form-async ref="editField" />
      <popup-menu v-model="popumMenuShow" :items="popupMenuList" :position="popupMenuPosition" @click="onClickMenu($event)" />
    </div>
  </static-fullscreen-card>
</template>

<script>
import { statusChange, getAccess, autoHeightBlock, popupMenu, genModel } from "@/components/mixings";
export default {
  mixins: [getAccess, statusChange, autoHeightBlock, popupMenu, genModel],
  components: {
    AddDocDialog: () => import("./../dialogs/addDocumentDialog"),
    editDialog: () => import("./../dialogs/objectDialog"),
    StateSaleDialog: () => import("./../dialogs/stateSaleDialog"),
    TabReports: () => import("./tabs/tabObjectReports"),
    TabFurnitureReports: () => import("./tabs/tabFurnitureReports"),
    TabContract: () => import("./tabs/tabContract"),
    TabGoods: () => import("./tabs/tabObjectGoods"),
    TabWorks: () => import("./tabs/tabObjectWorks"),
    TabDocs: () => import("./tabs/tabDocs"),
    TabBalance: () => import("./tabs/tabObjectBalance"),
    ViewPlanning: () => import("./planning/planningForm"),
    TabGoodsSummary: () => import("./tabs/tabObjectGoodsSummary"),
  },
  props: {
    idShow: Number,
  },
  data() {
    return {
      id: 0,
      oldDoc: false,
      loading: true,
      loaded: false,
      showAddDocDialog: false,
      addDocModel: null,
      showStateSaleDialog: false,
      objectTypeView: "tabObjectView-main",
      showEditDialog: false,
      title: "",
      data: {},
      m: this.$store.getters["config/get"].models.objects,
      model: this.$store.getters["config/get"].models.objects.form,
      mFinance: this.$store.getters["config/get"].models.finance,
      // url: "/mechti/objects",
      tab: 0,
      tab_photo: 0,
      tab_info: 0,
      balance: { debit: 0, credit: 0 },
      clientHeight: 0,
      _progress: [],
      balanceTable: { data: null, debit: 0, credit: 0 },
    };
  },
  created() {
    this.loading = true;
    if (!this.idShow) this.$root.title = this.$route.meta.title || "Объекты";
    this.id = this.idShow || Number(this.$route.params.id);
    this.permit = this.getAccess("menu.objects");
    this.fitchData();
    if (this.$attrs?.type) {
      //console.log("atttr type", this.$attrs.type);
      this.objectTypeView = this.$attrs.type;
    }
    if (this.$attrs?.tab) {
      this.tab = this.$attrs.tab;
    }
  },
  watch: {
    showEditDialog() {
      if (!this.showEditDialog) {
        this.fitchData();
      }
    },
    showAddDocDialog(v) {
      if (!v) {
        this.fitchData();
      }
    },
  },
  computed: {
    url() {
      let res;
      const api = this.m.api;
      if (typeof api == "object") {
        try {
          res = api.role[this.$root.profile.role].api;
        } catch (error) {}
      } else {
        res = api;
      }
      return res || "/mechti/objects";
    },
    objectProgress() {
      if (!this._progress.length) {
        this.getObjectProgress();
      }
      return this._progress;
    },
    modelRight() {
      let model = [];
      if (this.$root.profile.role == 10 || this.$root.profile.role == 20) {
        this.getObjectProgress();
        model = [
          ...this.calcModel("formInfo_role10"),
          { name: "data.investment_amount", title: "Сумма по договору", type: "number", showNull: true },
          { name: "balance_debit", value: (this.balanceData?.debit || 0).toLocaleString(), title: "Оплачено", type: "string", showNull: true },
          {
            name: "balance_credit",
            value: ((this.data?.data?.investment_amount || 0) - (this.balanceData?.debit || 0)).toLocaleString(),
            title: "К оплате",
            type: "string",
            showNull: true,
          },
          {
            name: "procress_1",
            title: "Комплектация",
            type: "string",
            calculated: true,
            formula: `((d) => {let p=d?._progress?.['Комплектация'] || null; return p ? p.per+'%' : null})`,
          },
          {
            name: "procress_2",
            title: "Дизайн",
            type: "string",
            calculated: true,
            formula: `((d) => {let p=d?._progress?.['Дизайнер'] || null; return p ? p.per+'%' : null})`,
          },
          {
            name: "procress_3",
            title: "Мебель",
            type: "string",
            calculated: true,
            formula: `((d) => {let p=d?._progress?.['Мебель'] || null; return p ? p.per+'%' : null})`,
          },
          {
            name: "procress_4",
            title: "Ремонт",
            type: "string",
            calculated: true,
            formula: `((d) => {let p=d?._progress?.['Стройка'] || null; return p ? p.per+'%' : null})`,
          },

          //, calculated: true, formula: `((d) => {return d.balanceCalc?.type_2 || null;})`
        ];
      }
      if (this.$root.profile.role > 20)
        model = [
          ...this.calcModel("formInfo"),
          { name: "user_name", title: "Менеджер проекта", type: "string" },
          // { name: "object_men", value: this.getUsersByRole(60), title: "Менеджер проекта", type: "selectuser" },
          { name: "object_teh", value: this.getUsersByRole(50), title: "Технадзор", type: "selectuser" },
          { name: "object_design", value: this.getUsersByRole(55), title: "Дизайнер проекта", type: "selectuser" },
        ];
      this.fillData(model);
      return model;
    },
    oModel() {
      let model = [];
      this.model.forEach((el) => {
        model[el.name] = el;
      });
      return model;
    },
    infoTabs() {
      let tabs = [
        {
          name: "auto-task",
          title: `задачи` + (this.data?.tasks?.length ? ` (${this.data?.tasks?.length})` : ""),
          show: this.data?.tasks?.length && this.getAccess("object.showAlertTask"),
        },
        { name: "info", title: "Информация", show: true },
        { name: "finance", title: "Финансы", show: this.$root.profile.role > 20 },
        { name: "goods", title: "Чек-лист", show: this.$root.profile.role > 20 && this.showTab({ name: "goods", show: true }) },
      ];
      return tabs;
    },
    tabs() {
      let tabs = [
        { name: "works", title: "График работ", icon: "mdi-arrow-expand", click: "goToWorks", show: this.$root.profile.role != 25 },
        { name: "goods", title: "Чек-лист", icon: "mdi-arrow-expand", click: "goToGoods", show: this.$root.profile.role != 25 },
        { name: "reports", title: "Фото отчеты", show: true },
        { name: "contract", title: "Договоры", show: this.$root.profile.role > 20 && this.$root.profile.role != 25 },
        { name: "furniture", title: "Работа-отчет", show: this.$root.profile.role > 20 && this.$root.profile.role != 25 },
        { name: "doc", title: "Проект", show: this.$root.profile.role != 25 },
        { name: "doc_adv", title: "Реклама", show: this.$root.profile.role != 25 },
        { name: "doc_law", title: "Юридические документы", show: this.$root.profile.role != 25 },
        { name: "doc_furniture", title: "Мебель", show: this.$root.profile.role != 25 },
        { name: "balance", title: "Баланс", show: this.$root.profile.role != 25 },
      ];
      return tabs;
    },
    balanceData() {
      if (!this.balanceTable.data) this.getBalanceTable();
      return this.balanceTable;
    },
    modelFinance() {
      let model = JSON.parse(JSON.stringify(this.mFinance.list));
      model.forEach((el) => {
        if (el?.sourceList) {
          el.options = this.mFinance[el.sourceList];
        }
      });
      return model;
    },
    balanceText() {
      const balance = this.balanceData && this.balanceData.debit !== undefined ? this.balanceData : this.balance;
      if (!balance.debit && !balance.credit) return "нет данных";
      return (balance.debit || 0).toLocaleString() + " - " + (balance.credit || 0).toLocaleString() + " = " + Number(balance.debit - balance.credit).toLocaleString();
    },
    investmentText() {
      //console.log("investmentText", this.balanceData.debit, this.balance);
      const balance = this.balanceData && this.balanceData.debit ? this.balanceData : this.balance;
      const investment = this.data.data?.investment_amount ? Number(this.data.data.investment_amount).toLocaleString() : "???";
      if (!balance.debit && !investment) return "нет данных";
      return (balance.debit !== null ? balance.debit.toLocaleString() : "???") + " из " + investment;
    },

    object_employees____() {
      let a = this.data.object_access ? this.data.object_access.filter((el) => el.user_role < 100) : [];
      return a;
    },
    object_users() {
      const users = (this.$dir.get("user") || []).map((item) => ({ ...item })); //this.$root.dirs.user;
      let res = this.data.object_access;
      for (let i = 0; i < res.length; i++) {
        res[i].role = users.find((u) => u.value == res[i].user_id)?.role || null;
      }
      return res;
    },
    editObject() {
      return this.getAccess("object.edit", {
        id: this.id,
        access: this.data.object_access,
        data: this.data,
      });
    },
    showObject() {
      return (
        this.getAccess("object.edit", {
          id: this.id,
          access: this.data.object_access,
          data: this.data,
          inRole: -1,
        }) || this.getAccess("object.view")
      );
    },
    statusObject() {
      //console.log(this.$root.profile);
      return this.getAccess("object.status", {});
    },
    editObjectGoods() {
      //console.log(this.$root.profile);
      const access = this.data.object_access || [];
      return this.getAccess("object.edit", {
        access: access.filter((a) => a.user_role == 55),
      });
    },
    isTypeFurniture() {
      return this.data.object_type & (1 << (3 - 1));
    },
    isTypeWork() {
      return this.data.object_type & (1 << (2 - 1));
    },
    isTypeDesign() {
      return this.data.object_type & (1 << (1 - 1));
    },
  },
  methods: {
    async checkObjectCanComplete() {
      try {
        const res = await this.$axios.post("/report_sql", { name: "checkObjectForComplete", params: { id: this.data.id } });
        if (res?.data?.status == "ok") {
          if (res.data.data.length == 0) return "ok";
          return `На объекте ${res.data.data.length} незавершенных работ. Смена статуса невозможна`;
        }
      } catch (error) {}

      return "Ошибка при проверке. ";
    },
    fillData(model) {
      for (let el of model) {
        if (el?.calculated == true) {
          if (el?.formula) {
            let f = el.formula;
            if (!this.data.hasOwnProperty(el.name))
              Object.defineProperty(this.data, el.name, {
                get: function () {
                  let res = 0;
                  let func;
                  if (typeof f == "function") func = f;
                  if (typeof f == "string") func = eval(f);
                  res = func(this);
                  return res;
                },
              });
          }
        }
      }
    },
    async getObjectProgress() {
      let params = { id: this.id };
      let resp = await this.$axios.post("/report_sql", { name: "getObjectProgress", params });

      let d = resp?.data?.data || [];
      this._progress = [...(resp?.data?.data || [])];
      let p = {};
      d.forEach((r) => (p[r.name] = { per: r.per, t: r.total }));
      this.data._progress = p;
    },
    getUsersByRole(r) {
      ///console.log(this.$root?.dirs?.user);
      //let a = this.data.object_access ? this.data.object_access.filter((el) => el.user_role == r && el.user_status == 1) : [];
      console.log("getUsersByRole", this.object_users);
      let a = this.object_users ? this.object_users.filter((el) => el.user_role == r && el.user_status == 1) : [];
      return a;
    },
    showTab({ name, show }) {
      let res = true;
      if (!show) return show;
      if (name.includes("doc_") || name == "doc") {
        res = this.getAccess(`object.doc.${name}`, null, true);
      }
      if (name == "balance") return this.getAccess("object.showBalance");
      if (name == "doc_furniture") return res && this.isTypeFurniture;
      if (name == "goods") return this.isTypeWork || this.isTypeFurniture;
      if (name == "reports") return this.isTypeWork;
      if (name == "doc_adv") return res && this.isTypeWork && this.isTypeFurniture && this.isTypeDesign;
      return res;
    },
    showDocs(field) {
      return this.model.find((el) => el.name == field)?.category || -1;
    },
    addNewDocs(field) {
      this.addDocModel = this.model.find((el) => el.name == field) || null;
      if (!this.addDocModel) return;
      this.showAddDocDialog = true;
    },
    changeTab(tab, type = "tab") {
      if (!this.idShow) this.$router.push({ query: { [type]: tab } });
    },
    async fitchData() {
      try {
        const d = await this.$axios.get(this.url + "/" + this.id);
        if (d.data && d.data.data) {
          /*       for (const name in d.data.data) {
          if (name == "data" && this.data?.data && !d.data.data[name]) {
            for (const nameData in d.data.data.data) {
              this.$set(this.data.data, nameData, d.data.data.data[nameData]);
            }
          } else this.$set(this.data, name, d.data.data[name]);
        } */
          this.data = d.data.data;
        }
      } catch (error) {
        this.$root.$emit("show-info", {
          text: "Данные не доступны.",
          type: "error",
        });
        this.loading = false;
        return;
      }

      // await this.getBalance();
      this.loading = false;
      this.loaded = !false;
    },
    async getBalanceTable() {
      let res = [];

      let resp = await this.$axios.post("/report_sql", { name: "getObjectBalance", params: { id: this.id } });

      //      let resp = await this.$axios.post("accounting/records/report-sql", { q });

      let debit = 0;
      let credit = 0;
      if (resp.data.status == "ok") {
        res = resp.data.data;
        //  console.log("get balance table", res);
        resp.data.data.forEach((el) => {
          if ([35, 36, 48].includes(el.operation_id)) {
          } else {
            //console.log(el.operation_id, el);
            debit += el.value_cr;
            credit += el.value_db;
          }
        });
      }
      this.balanceTable = { data: res, debit, credit };
    },

    updateData() {
      this.fitchData();
    },
    clickTabIcon(t) {
      this[t.click]();
    },
    goToGoods() {
      this.$router.push({ name: "objects_goods", params: { id: this.id } });
    },
    goToWorks() {
      this.$router.push({ name: "objects_works", params: { id: this.id } });
    },
    async getBalance(filter = { object_id: this.id }) {
      const response = await this.$axios.get("/mechti/finance/balance", {
        params: { filters: filter },
      });
      this.balance = response.data.data;
    },
    async onSelectEstimate() {
      const ok = await this.$root.$confirm({
        title: "Импорт ",
        message: ["Будут импортированны настройки комнат на объекте, покупки и график работ", "Вы хотите продолжить?"],
        okButton: "Да",
        cancelButton: "Нет",
      });

      if (!ok) return;
      let resp = await this.$axios.post("/report_sql", { name: "checkObjectForImport", params: { id: this.id } });
      if (resp.data.status == "ok") {
        let res = resp.data.data[0];
        if (res.goods !== 0) {
          this.$root.$emit("show-info", {
            text: "На объекте заполнен чеклист. Импорт невозможен",
            type: "error",
          });
          return;
        }
        if (res.works !== 0) {
          this.$root.$emit("show-info", {
            text: "На объекте заполнен график. Импорт невозможен",
            type: "error",
          });
          return;
        }
      } else {
        this.$root.$emit("show-info", {
          text: "Ошибка при проверке возможности импрота",
          type: "error",
        });
      }
      let source = this.m?.sources?.estimate;
      if (!source) {
        this.$root.$emit("show-info", {
          text: "Не настроен выбор источника",
          type: "error",
        });
        return;
      }
      source = {
        api: "/report_sql/filters",
        title: "Выберите источник",
        width: 1000,
        paramsApi: { name: "getListSourceForImportToObject", params: { object_id: this.id } },
        model: {
          list: [
            { name: "id", title: "#", type: "string", width: "30" },
            { name: "name", title: "Тип", type: "string", sortable: true, width: "70" },
            { name: "code_doc", title: "Номер", type: "string", sortable: true, width: "90" },
            { name: "date_doc", title: "Дата", type: "date", sortable: true, width: "95" },
            { name: "client_id", title: "Клиентт", type: "select", dir: "client", sortable: true, width: "220" },
            { name: "object_id", title: "Объект", type: "select", dir: "object", sortable: true, width: "190" },
            { name: "service_count", title: "Услуг", type: "number", sortable: true, width: "55" },
            { name: "goods_count", title: "Товаров", type: "number", sortable: true, width: "55" },
            { name: "rooms_count", title: "Комнат", type: "number", sortable: true, width: "55" },
          ],
        },
        fields: "id,name,code_doc,date_doc,client_id,object_id,service_count,goods_count,rooms_count",
      };
      let res = await this.onGetSource({ source });
      if (res) {
        this.importData(res);
      } else {
      }
    },

    async onGetSource(e) {
      return this.$refs.selectList.show(e);
    },
    async importData(el) {
      let res = await this.$axios.get("/mechti/objects/" + this.id);
      const object = res?.data?.data;

      if (el.source == "estimate") {
        let m = this.$store.getters["config/get"].models.documentEstimate;
        let res = await this.$axios.get(m.api + "/" + el.id);
        let estimate = res.data.data;

        let rooms = estimate.data_table[0].map((r) => {
          return {
            name: r.name,
            level: r.data.level,
            room_number: r.data.room_number,
            room_type: r.room_type,
            room_class: r.room_class,
            room_square: r.room_square,
            wall_height: r.wall_height,
            wall_length: r.wall_length,
            room_id: r.id,
          };
        });

        if (object.id) {
          let data = object.data;
          data.rooms = rooms;
          await this.$axios.post("/mechti/objects", { id: object.id, data });
          this.$root.$emit("show-info", {
            color: "blue",
            text: "Комнаты импортированы",
            type: "info",
          });
        }
        let goods = estimate.data_table[1].map((g) => {
          let room = rooms.find((r) => r.room_id == g.room_id);
          return {
            data: {
              rooms: room ? [room] : [],
              room_class: room?.room_class,
              price_comfort: g.data.price_comfort,
              price_business: g.data.price_business,
              price_premium: g.data.price_premium,
              import_id: g.id,
            },
            room_type: room?.name,
            goods_type_id: g.good_id,
            category_id: g.category_id,
            name: g.name,
            amount: g.amount,
            price: g.price,
            status: -2,
            object_id: this.id,
          };
        });
        if (object.id) {
          await this.$axios.post("/mechti/construction-goods", [...goods]);
          this.$root.$emit("show-info", {
            color: "blue",
            text: "Товары импортированы",
            type: "info",
          });
        }
        let params = {};
        params.filters = {
          category_id: [28, 27, 29],
        };
        res = await this.$axios.get("accounting/dir/service", { params });
        const services = res.data.data;
        let works = estimate.data_table[2].map((w) => {
          // let room = rooms.find((r) => r.room_id == w.room_id);
          let service = services.find((s) => s.id == w.service_id);

          let result = {
            department: null,
            service_id: w.service_id,
            work_days: service?.data?.work_days,
            work_value: service?.data?.work_value,
            work_cost: w.value,
            date_start: null,
            date_end: null,
            status: -1,
            data: Object.assign(w.data, {
              description: w.comments || service?.data?.description,
              category_id: service?.category_id,
              import_id: w.id,
              price: w.price,
            }),
            object_id: this.id,
            name: service?.name,
          };
          return result;
        });
        if (object.id) {
          await this.$axios.post("/mechti/construction-schedule", [...works]);
          this.$root.$emit("show-info", {
            color: "blue",
            text: "Работы импортированы",
            type: "info",
          });
        }
      } else if (el.source == "contract") {
        let params = {};
        params.filters = {
          category_id: [28, 27, 29],
        };
        let m = this.$store.getters["config/get"].models.contracts;
        let res = await this.$axios.get(m.api + "/" + el.id);
        let data = res.data.data;

        res = await this.$axios.get("accounting/dir/service", { params });
        const services = res.data.data;
        const s = data.template_data.find((t) => t.type == 4)?.data || [];
        let works = s.map((w) => {
          // let room = rooms.find((r) => r.room_id == w.room_id);
          let service = services.find((s) => s.id == w.service_id);

          let result = {
            department: null,
            service_id: w.service_id,
            work_days: service?.data?.work_days,
            work_value: service?.data?.work_value,
            work_cost: w.work_cost,
            date_start: null,
            date_end: null,
            status: -1,
            data: {
              description: w.comments || service?.data?.description,
              category_id: service?.category_id,
              import_id: w.id,
              price: w.work_cost,
            },
            object_id: this.id,
            name: service?.name,
          };
          return result;
        });
        if (object.id) {
          await this.$axios.post("/mechti/construction-schedule", [...works]);
          this.$root.$emit("show-info", {
            color: "blue",
            text: "Работы импортированы",
            type: "info",
          });
        }
      } else {
        this.$root.$emit("show-info", {
          text: "Неизвестный источник для импорта",
          type: "error",
        });
      }

      //console.log({ rooms, goods, works });
    },
    async tryRedirect() {
      let model = Object.assign(
        {},
        this.m.form.find((f) => f.name == "user_id")
      );
      model["readonly"] = false;
      model["isActiveFunc"] = `[${model["dirFilter"].role.join()}].includes(d.role)`;
      model["dirFilter"] = null;
      model["autocomplete"] = true;
      model["hideInactive"] = true;

      let res = await this.$refs.editField.show({
        title: "Передача объекта менеджеру",
        data: { user_id: this.data.user_id },
        model: [model],
      });
      if (res) {
        //console.log("yes", res);
        try {
          let data = { user_id: res.user_id, id: this.id };
          //console.log(data);
          await this.$axios.post(this.url, data);
          this.$root.$emit("show-info", { type: "info", text: "Объект переназначен" });
          this.fitchData();
        } catch (error) {
          this.$root.$emit("show-info", { type: "error", text: "Произошла ошибка." });
          console.error(error);
        }
      } else {
        console.log("no", res);
      }
      return false;
    },
    async onEditField(e) {
      return this.$refs.editField.show(e);
    },
  },
};
</script>

<style lang="sass">
.v-slide-group1__prev--disabled
  display: none !important
.v-slide-group1__next--disabled
  display: none !important
</style>
